export default __webpack_public_path__ + "1646ad9ba98ce2a2a5ef0394886651fa.svg";